import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER, PATHS } from '../constants';
import { formatQueryParams, getCategorySlug, getSubCategorySlug } from '../helperFunctions';
import type { MapperItemConfig } from './types';

export const getSubCategoryPath = ({ categoryId, id, filter, queryParams, source }: MapperItemConfig) => {
    if (!(categoryId && id)) {
        return PATHS.ROOT;
    }

    if (isNaN(parseInt(categoryId, 10)) || isNaN(parseInt(id, 10))) {
        return PATHS.ROOT;
    }

    const categorySlug = getCategorySlug(categoryId);
    const subCategorySlug = getSubCategorySlug(id);
    const params = {
        category_id: categorySlug,
        id: subCategorySlug,
    };

    return pathfinder(PATHFINDER.SUB_CATEGORY, params, formatQueryParams({ filter, queryParams, source }));
};
